import React, { useRef } from 'react';
import { useLocation } from 'react-router';
import { ROUTES, SVG_TYPE, USER_ROLES } from 'Shared/enums';
import { useEffect, useState } from 'react';
import { NavLink, generatePath } from 'react-router-dom';
import SVG from 'Components/SVG';
import { MainType } from './Container';

function Navigation(props: MainType) {
  const {
    actions: { getAuthorizedUser },
    authorizedUser,
  } = props;
  const location = useLocation();
  const { pathname } = location;
  const isDashboard = pathname.split('/')[1] === 'dashboard';
  const isMobile = window.innerWidth < 1024;
  const isPacketPage = pathname === ROUTES.MYPROFILE_PACKET && isMobile;
  const isExamPage = pathname === ROUTES.EXAM && isMobile;
  const isLessonPage = pathname.includes('lesson') && isMobile;
  const [isNavVisible, setIsNavVisible] = useState(true);
  const [isNavOpen, setIsNavOpen] = useState(!isMobile);
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    const slide: any = document.querySelector('.slide');
    if (!slide) return;

    if (isDashboard && !isPacketPage) {
      setIsNavVisible(true);
      if (isMobile) {
        slide.style.height = 'calc(100% - 81px)';
      } else {
        slide.style.height = '100vh';
        slide.style.overflow = 'auto';
      }
    } else {
      slide.style.overflow = 'hidden';
      setIsNavVisible(false);
      if (isExamPage) {
        slide.style.height = 'calc(100% - 81px)';
      } else {
        slide.style.height = '100%';
        slide.style.width = '100%';
      }
    }
  }, [isDashboard, isPacketPage, isMobile, isExamPage, isLessonPage]);

  useEffect(() => {
    const slide: any = document.querySelector('.slide');
    if (!slide) return;

    if (isLessonPage) {
      setIsNavVisible(false);
      slide.style.height = '100%';
    }
  }, [isLessonPage]);

  useEffect(() => {
    if (!authorizedUser) {
      getAuthorizedUser();
    } else {
      setUserRole(authorizedUser.role);
    }
  }, [authorizedUser, getAuthorizedUser]);
  const navigationRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (navigationRef.current && !navigationRef.current.contains(event.target)) {
        setIsNavOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const linkToQuestionDatabase = generatePath(ROUTES.QUESTIONS_DATABASE, { category: 'all', page: '1' });
  const linkToUsers = generatePath(ROUTES.USERS, { role: 'client', page: '1' });
  const linkToLearning = generatePath(ROUTES.LEARNING, { submenu: 'departments' });
  const isAIPageActive = pathname.startsWith('/dashboard/ai');
  const isQuestionDatabaseActive = pathname.startsWith('/dashboard/question-database');
  const isUsersActive = pathname.startsWith('/dashboard/users');
  const isLearningPageActive = pathname.startsWith('/dashboard/learning');
  const isHomePageActive = pathname.startsWith('/dashboard/home');

  return (
    <>
      {isNavVisible ? (
        <>
          <nav ref={navigationRef} className={`navigation ${isNavOpen ? 'navigation--open' : ''}`}>
            {!isMobile && (
              <div className="navigation-item navigation__logo" onClick={() => setIsNavOpen(!isNavOpen)}>
                <SVG type={SVG_TYPE.LOGO_ROYAL} />
              </div>
            )}
            {userRole === USER_ROLES.CLIENT && (
              <>
                {isMobile ? (
                  <NavLink to={ROUTES.HOME} className={`${isHomePageActive ? 'navigation-item active' : 'navigation-item'}`}>
                    <SVG type={SVG_TYPE.HOME} />
                    <div className="navigation-item__name">Start</div>
                  </NavLink>
                ) : null}
                <NavLink to={linkToLearning} className={`${isLearningPageActive ? 'navigation-item active' : 'navigation-item'}`}>
                  <SVG type={SVG_TYPE.STUDY} />
                  <div className="navigation-item__name">Nauka</div>
                </NavLink>
                <NavLink to={ROUTES.EXAM} className="navigation-item">
                  <SVG type={SVG_TYPE.EXAM} />
                  <div className="navigation-item__name">Egzamin</div>
                </NavLink>
                {!isMobile ? (
                  <NavLink to={ROUTES.GAMIFICATION} className="navigation-item navigation-item--soon">
                    <SVG type={SVG_TYPE.TROPHY} />
                    {!isMobile && <div className="navigation-item__name navigation-item__name--darkest">Grywalizacja (wkrótce)</div>}
                  </NavLink>
                ) : null}
                <NavLink to={ROUTES.MYPROFILE} className="navigation-item">
                  <SVG type={SVG_TYPE.PERSON} />
                  <div className="navigation-item__name">Profil</div>
                </NavLink>
                {!isMobile ? (
                  <NavLink to={ROUTES.AI} className={`${isAIPageActive ? 'navigation-item active' : 'navigation-item'} navigation-item--ai`}>
                    <SVG type={SVG_TYPE.ROBOT} />
                    {!isMobile && <div className="navigation-item__name">Instruktor AI</div>}
                  </NavLink>
                ) : null}
              </>
            )}
            {userRole === USER_ROLES.ADMIN && (
              <>
                <NavLink to={ROUTES.STATISTICS} className="navigation-item">
                  <SVG type={SVG_TYPE.STATS} />
                  {!isMobile && <div className="navigation-item__name">Statystyki</div>}
                </NavLink>
                <NavLink to={linkToUsers} className={` ${isUsersActive ? 'navigation-item active' : 'navigation-item'}`}>
                  <SVG type={SVG_TYPE.USERS} />
                  {!isMobile && <div className="navigation-item__name">Lista użytkowników</div>}
                </NavLink>
                <NavLink to={linkToQuestionDatabase} className={`${isQuestionDatabaseActive ? 'navigation-item active' : 'navigation-item'}`}>
                  <SVG type={SVG_TYPE.FOLDER_QUESTION} />
                  {!isMobile && <div className="navigation-item__name">Baza pytań</div>}
                </NavLink>
                <NavLink to={`${ROUTES.ADMIN_LEARNING}?page=1&type=Wszystkie`} className="navigation-item">
                  <SVG type={SVG_TYPE.STUDY} />
                  {!isMobile && <div className="navigation-item__name">Nauka</div>}
                </NavLink>
                <NavLink to={ROUTES.MYPROFILE} className="navigation-item">
                  <SVG type={SVG_TYPE.PERSON} />
                  {!isMobile && <div className="navigation-item__name">Profil</div>}
                </NavLink>
              </>
            )}
          </nav>
        </>
      ) : null}
    </>
  );
}

export default Navigation;
